import apiClient from "../api/apiClient"
import { endPoints } from "../config/endpoints";

export const categoryService = {
  async getDropdownAsync() {
    const response = await apiClient.get(endPoints.category.dropdown);
    return response.data;
  },
  async getAllAsync(params) {
    const response = await apiClient.get(endPoints.category.getAll, {
      params: params,
    });

    return response.data;
  },
  async getAllSearchAsync(params, signal) {
    const response = await apiClient.get(endPoints.category.getAllSearch, {
      params: params,
      signal: signal,
    });

    return response.data;
  },
  async toggleActivate(id) {
    const response = await apiClient.patch(
      `${endPoints.category.toggleActivate}/${id}`,
    );
    return response.data;
  },
  async create(data) {
    const response = await apiClient.post(endPoints.category.create, data);
    return response.data;
  },
  async update(id, data) {
    const response = await apiClient.post(
      `${endPoints.category.update}/${id}`,
      data,
    );
    return response.data;
  },
  async edit(id) {
    const response = await apiClient.get(`${endPoints.category.edit}/${id}`);
    return response.data;
  },
  async deleteImageAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.category.deleteImage}/${id}`,
    );
    return response.data;
  },
   async deleteAsync(id) {
    const response = await apiClient.delete(
      `${endPoints.category.delete}/${id}`,
    );
    return response.data;
  },
  async getDetails(id) {
    const response = await apiClient.get(
      `${endPoints.category.getDetails}/${id}`,
    );
    return response.data;
  }
};